import { RestService } from "../../../core/core/rest.service";
import { Role } from "./role-details.model";
import { Injectable } from "@angular/core";
import { User } from "../../users/users.model";
import { ObjectToSelect } from "../../../core/shared/objectToSelect.model";

@Injectable()
export class RoleDetailsRest{
    constructor(private http: RestService) { }
    
    public getRoleDetails(name: string) {
        return this.http.post<Role>(`api/roles/role/${name}`, {});
    } 

    public removeUserFromRole(user: User, roleId: string) {
        return this.http.post(`api/roles/role/removeuser/${roleId}`, user);
    }

    public saveRole(role: Role) {
        return this.http.post('api/roles/role/save', role);
    }

    public getUsersToAdd(roleId: string) {
        return this.http.get<ObjectToSelect[]>(`api/roles/role/getUsersToAdd/${roleId}`);
    }

    public checkUserCurrentRole(userId: string) {
        return this.http.get<string>(`api/roles/role/checkUserCurrentRole/${userId}`);
    }

    public assignUserToRole(roleName: string, userId: string) {
        return this.http.post<string>(`api/roles/role/assignUserToRole/${roleName}/${userId}`, {});
    }

    public createNewRole(roleName: string){
        return this.http.post<string>(`api/roles/role/new`, roleName);
    }

    public deleteRole(roleName: string){
        return this.http.post<string>(`api/roles/role/delete`, roleName);
    }
}